<template>
    <div class="footer-item">
        <div class="icon-wrap">
            <slot />
        </div>
        <span class="label">{{ title }}</span>
    </div>
</template>

<script>
export default {
    name: 'MenuItemFooter',
    props: ['title'],
}
</script>

<style scoped>
.footer-item {
    display: flex;
    flex: 1 1 0;
    min-width: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 0 2px;
    cursor: pointer;
}

.icon-wrap {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-wrap :deep(svg) {
    display: block;
    width: 24px;
    height: 24px;
}

.label {
    width: 100%;
    font-size: 10px;
    font-weight: 400;
    line-height: 1.2;
    color: #525c68;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
